/**
 * Warehouse-style mega menu hover behavior (desktop only).
 *
 * Dawn's mega menu uses <details>. CSS cannot open <details> on hover,
 * so we toggle the `open` attribute with JS.
 */

(function () {
  const DESKTOP_MQ = window.matchMedia('(min-width: 990px)');

  function closeAll(exceptDetails) {
    document.querySelectorAll('.header__inline-menu details.mega-menu[open]').forEach((d) => {
      if (exceptDetails && d === exceptDetails) return;
      d.removeAttribute('open');
      const s = d.querySelector('summary');
      if (s) s.setAttribute('aria-expanded', 'false');
    });
  }

  function enhance(details) {
    const summary = details.querySelector('summary');
    const content = summary ? summary.nextElementSibling : null;
    if (!summary || !content) return;

    let closeTimer = null;

    const open = () => {
      if (!DESKTOP_MQ.matches) return;
      clearTimeout(closeTimer);
      closeAll(details);
      if (!details.hasAttribute('open')) {
        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
      }
    };

    const scheduleClose = () => {
      if (!DESKTOP_MQ.matches) return;
      clearTimeout(closeTimer);
      closeTimer = window.setTimeout(() => {
        // If focus is inside, do not close.
        if (details.contains(document.activeElement)) return;
        details.removeAttribute('open');
        summary.setAttribute('aria-expanded', 'false');
      }, 200);
    };

    details.addEventListener('mouseenter', open);
    details.addEventListener('mouseleave', scheduleClose);
    content.addEventListener('mouseenter', open);
    content.addEventListener('mouseleave', scheduleClose);

    // Keyboard users: open on focus.
    summary.addEventListener('focus', open);
  }

  function init() {
    document.querySelectorAll('.header__inline-menu details.mega-menu').forEach(enhance);
  }

  // Close all menus when switching to mobile.
  DESKTOP_MQ.addEventListener?.('change', (e) => {
    if (!e.matches) closeAll();
  });

  document.addEventListener('DOMContentLoaded', init);
})();
